import type { FC, HTMLAttributes, ReactNode } from 'react';

import { TypographyStyled } from './Typography.styled';

type TypographyPropsT = HTMLAttributes<HTMLParagraphElement> & {
  children: ReactNode;
  size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  color?:
    | 'black'
    | 'light'
    | 'darkBlue'
    | 'primaryText'
    | 'lightGrey'
    | 'grey'
    | 'darkGrey'
    | 'dark'
    | 'purple'
    | 'yellow'
    | 'success'
    | 'warning'
    | 'error'
    | 'semiTransparent'
    | 'darkGreen'
    | 'darkPurple';
  align?: 'left' | 'right' | 'center';
  family?: 'primary' | 'secondary';
  variant?:
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'body1'
    | 'body2'
    | 'body3'
    | 'body4'
    | 'body5'
    | 'body6';
  weight?: 'normal' | 'medium' | 'semibold' | 'bold';
  isInline?: boolean;
};

const Typography: FC<TypographyPropsT> = ({ children, variant, ...restProps }) => {
  const tagName = variant?.includes('h') ? variant : 'p';

  return (
    <TypographyStyled variant={variant} as={tagName} {...restProps}>
      {children}
    </TypographyStyled>
  );
};

export default Typography;
